import { Redirect } from 'react-router-dom';
import TopLevelRoutes from '../../routing/routes';

const GotoOtl = () => <Redirect to={TopLevelRoutes.OTL} />;

export default GotoOtl;
